<template>
    <div>
        <div class="container-fluid">
            <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''">
            </div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
            <div class="row">
                <div class="col-12" v-html="content">
                    <!--div class="content-pages" v-if="this.$root.store === 1">
                        <h2 class="page-title">ABOUT US</h2>
                        <p>Born in 2001, the brand W is a part of TCNS CLOTHING CO. LIMITED. The dream of two brothers –
                            Mr. OS Pasricha and Mr. AS Pasricha came to reality when W started its journey with an aim
                            to provide fashion in a modern retail environment to the Indian woman. We are the only brand
                            in the Indian retail space which offers 'Indian contemporary' wear and stays a step ahead of
                            the fashion curve. The pioneer in introducing the concept of 'Mix n Match' in retail, W
                            designers take inspiration from the latest fashion trends & forecasts from the west and
                            transform them into silhouettes and styles acceptable to the modern Indian woman. Our first
                            brand Store was opened in 2001-2002 at Lajpat Nagar, New Delhi. And now when we are standing
                            in 18thyear the store count is 300+ across the globe. The idea is not to grow only within
                            India but internationally. W's exclusive brand outlets are now present in Mauritius,
                            Srilanka & Kathmandu and are now looking forward to expand in more countries.
                        </p>

                        <h3>Mission:</h3>
                        <p>W's core mission is to provide complete wardrobe solution to the modern Indian woman. Started
                            in 2001, the aim was to fill the gap by providing contemporary Indian ethnic wear in
                            organized modern retail format. We aim to grow nationally as well as globally to cater a
                            larger clientele through both retail and e-commerce space.</p>

                        <h3>Vision:</h3>
                        <p>W wants to become the most preferred fashion brand for the modern Indian woman.</p>

                        <h3>Values:</h3>
                        <p>With the thought of changing the Indian fashion landscape forever, our products outshine the
                            W women from the rest. Our focus is on quality material, design, fit and sizing. We are the
                            first fashion brand to study about Indian woman's shape, fits and size classification and
                            came up with 7 instead of regular 3 sizes. We keep evolving with the changing tides of
                            fashion, keeping the pace with Indian ever-changing never-changing woman and rendering
                            ourselves indispensable. Our core values of Integrity, Result Orientation, Speed, Innovation
                            and Camaraderie reflects across organization. The work culture of W is all about inclusion,
                            collaboration, high performance and opportunity. We also ensure that all our actions are in
                            service of our Vision, Mission and values. W Head office is located in New Delhi, India TCNS
                            CLOTHING CO. LIMITED. Corporate Office: W-House, 119, Neelagagan Towers, Mandi Road,
                            Sultanpur, Mehrauli, New Delhi-110030 Registered Address: Unit No. 112, F/F, Rectangle 1,
                            D-4, Saket, District Centre, New Delhi, South Delhi, Delhi, India, 110017</p>
                    </div>
                    <div class="content-pages" v-if="this.$root.store === 2">
                        <h2 class="page-title">ABOUT US</h2>
                        <p>Born in 2009, the brand Aurelia is a part of TCNS CLOTHING CO. LIMITED., a company owned by
                            two brothers – Mr. OS Pasricha and Mr. AS Pasricha. They started their journey with W, the
                            brand in the Indian retail space that offers 'Indian contemporary' women's wear. Next was
                            the brand Aurelia, with an aim to make Indian wear more intriguing, affordable and easy to
                            wear for modern Indian women.</p>
                        <p>Aurelia re-defines Indian Ethnic by staying in the realm of traditions, yet adapting some
                            modern influences. The brand has successfully expanded its retail footprints in the country
                            with over 200+ standalone stores across 90+ cities. Aurelia also opened its flagship outlet
                            in Sri Lanka and looking forward to make its presence in many more countries.</p>
                        <p>Aurelia's mission is to increase brand accessibility via brand presence at various points
                            through associating with different sales channels. We wish to become the leading brand in
                            Indian wear segment and celebrate the effortless beauty of womanhood. We cater to the
                            quintessential Indian woman, who seeks a branded experience with consistent good quality
                            product with great fit and sharp pricing. Starting from a basic to occasion-ready, casual to
                            formal, day to night, Aurelia has a fusion approach that is a combination of modern
                            silhouettes with perfect mix of traditions and culture.</p>
                        <p>The work culture of Aurelia is all about inclusion, collaboration, high performance and
                            opportunity. We also ensure that all our actions are in service of our Vision, Mission and
                            values.</p>
                        <h3>Aurelia Head office is located in New Delhi, India.</h3>
                        <p>TCNS CLOTHING CO. LIMITED.<br>
                            119 & 127, Neelagagan Towers,<br>
                            Mandi Road, Sultanpur, Mehrauli,<br>
                            New Delhi-110030</p>
                        <h3>Registered Address:</h3>
                        <p>TCNS CLOTHING CO. LIMITED.<br>
                            Unit No. 112, F/F, Rectangle 1, D-4<br>
                            Saket, District Centre<br>
                            New Delhi, South Delhi, Delhi, India, 110017</p>
                    </div-->
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'company',
        metaInfo() {
            return {
                title: this.meta_title,
                meta: [
                    {
                        name: 'description',
                        content: this.meta_description
                    },
                    {
                        property: 'keywords',
                        content: this.meta_keyword
                    }
                ]
            }
        },
        data() {
            return {
                meta_title: '',
                meta_description: '',
                meta_keyword: '',
                content:''
            };
        },
        beforeMount() {
            this.$root.page_loader = true;
            axios.get(this.$root.api_url+`/pim/pimresponse.php?service=cms_page&url_key=about&store=${this.$root.store}`)
            .then(response => {
                this.$root.page_loader = false;
                if(response.data.response.success==1){
                    this.$root.breadcrumb = response.data.result[0].name;
                    this.$root.page_loader = false;
                    this.content=response.data.result[0].content;
                    this.meta_title = response.data.result[0].meta_title;
                    this.meta_description = response.data.result[0].meta_description;
                    this.meta_keyword = '';
                }
                else
                {
                    this.$router.push('/404');
                }
            }).catch(error=>{
                this.$root.page_loader = false;
            })
        },
        created() {
            window.scrollTo(0, 0);
            // this.$root.breadcrumb = 'About Us';
            // if (this.$root.store === 1) {
            //     this.meta_title = 'Online Ethnic Wear Brand for Women - W For Woman';
            //     this.meta_description = 'Shop ethnic wear for women online at best prices. Buy latest collection of kurta/kurtis, suits, lehenga, palazzo &amp; salwar kameez for women at exciting discounted prices.';
            //     this.meta_keyword = 'Ethnic wear brand for women, women kurta, lehenga, palazzo, salwar kameez';
            // }
            // else {
            //     this.meta_title = 'Aurelia - Leading Ethnic Wear brand for Women in India';
            //     this.meta_description = 'Shop affordable ethnic wear for women with our exclusive range of kurtas, kurtis, salwars, gilets, kurta sets, churidara and salwar, palazzo and skirts. FREE Shipping, COD, Easy Return options available only at Aurelia.';
            //     this.meta_keyword = 'kurtas, kurtis, salwars, gilets, kurta sets, churidara and salwar, palazzo and skirts';
            // }
        }
    }
</script>